import * as yup from 'yup'
import { INVALID_SYMBOLS, NUMBER_CANNOT_BE_NEGATIVE, REQUIRED_FIELD } from 'constants/errors'
import { validateDecimalPlaces } from 'utils/validateFloatWithPlaces'
import { DECIMAL_PLACES } from 'constants/calcConstants'

export const schemaSetLimit = yup.object().shape({
  limit: yup
    .number()
    .typeError(INVALID_SYMBOLS)
    .positive(NUMBER_CANNOT_BE_NEGATIVE)
    .test('float', INVALID_SYMBOLS, function () {
      return validateDecimalPlaces(+this.parent.limit, DECIMAL_PLACES)
    })
    .required(REQUIRED_FIELD),
})
